<template>
  <div class="creat-reports-vue-container"
       element-loading-text="Сохранение табеля..."
       v-loading="loading">
    <div>
      <el-form v-loading="loader" class="reports-create" label-position="top">
        <div class="reports-edit-header" v-if="$route.params.id">
          <div @click="deleteReport" class="i-container">
            <i class="el-icon-delete"></i>
            <span>Удалить табель</span>
          </div>
          <div
            @click="copyData.dialogVisible = true"
            class="i-container"
          >
            <i class="el-icon-document-copy"></i>
            <span>Копировать табель</span>
          </div>
        </div>
        <div class="date-create">
          <div style="display: flex; align-items: center">

            <el-date-picker
              :editable="false"
              format="yyyy-MM-dd"
              v-model="form.timesheetDate"
              type="date"
              placeholder="Укажите дату"
            >
            </el-date-picker>
            <i class="el-icon-success" v-if="approved"></i>
          </div>

          <h4>
            <small>Номер отчета</small>
            #{{ index }}
          </h4>
        </div>

        <div>
          <div class="add-btn">
            <AddCompany
              :role="role"
              :currentUser="currentUser"
              :isSelect="!!form.company"
              @add-objects="addCompany"
            />
            <div class="report-li-title" v-if="form.company">
              Выбранная компания: <strong>{{ ` ` + form.company.name }}</strong>
            </div>
          </div>
        </div>

        <div :class="{'disabled-next': !form.company}">
          <div class="add-btn">
            <AddObjects
              :confirmDisable="true"
              :isSelect="!!form.object"
              @add-objects="addObject"
            />
            <div class="report-li-title" v-if="form.object">
              Выбранный объект: <strong>{{ ` ` + form.object.name }}</strong>
            </div>
          </div>

          <div class="controls-tabel">
            <el-checkbox v-model="selectAll" @input="selectAllChange"></el-checkbox>
            <div style="margin-left: 10px">
              <FilterUser
                @apply-filters="applyFilters"
                :users="optionsUsers"
                :company="form.company && form.company.id"
                :work-types="optionsWorkTypes"
                :isWorkType="isWorkType"
              />
            </div>
            <div style="margin-left: 10px; margin-right: 10px">
              <MultipleUser
                :role="role"
                :currentUser="currentUser"
                :companies="options.companies"
                :workDirs="options.dirs"
                :allUsers="options.users"
                @update="(e) => form.employees = e"
                :filter-users-props="filterUsers(form.employees, filters)"
                :users="form.employees"
                :companyData="form.company"
                :company="form.company && form.company.id"
                :work-types="options.work_type"
                :isWorkType="isWorkType"
              />
            </div>
            <el-switch v-model="isWorkType"></el-switch>
          </div>

          <div style="border-top: 1px solid rgba(0, 0, 0, 0.18); width: 100%; margin-top: 10px"
               v-if="form.employees.length"></div>
          <div class="user-list" v-if="form.employees.length && !isWorkType">
            <div class="user-container" v-for="(user, index) in filterUsers(form.employees, filters)">
              <div class="user-line"
                   :key="user.employeeId + '-' + index">
                <div class="user-section">
                  <el-checkbox v-model="user.isSelect" style="margin-right: 8px"></el-checkbox>
                  <i @click="editUser(index, user)" class="fa fa-edit" style="margin-right: 8px"/>
                  <span>{{ getName(user.employeeId) }}</span>
                </div>
                <div class="user-input-section">
                  <el-input class="padding-input-4" size="small" style="width: 32px; margin-right: 8px"
                            v-model="user.hours"></el-input>
                  <el-input class="padding-input-4" size="small" style="width: 32px" v-model="user.code"></el-input>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <template v-if="!$store.state.project.work_dir">
              <div class="user-list" :key="key" v-for="([c, users], key) in filterGroupUsers(form.employees, filters)">
                <div v-if="c" style="display: flex; flex: 1; justify-content: flex-start; margin-top: 20px">
                  <strong>{{ getWorkName(c) }}</strong>
                </div>
                <div v-else style="display: flex; flex: 1; justify-content: flex-start; margin-top: 20px">
                  <strong>Без вида работ</strong>
                </div>
                <div class="user-container" v-for="(user, index) in users" :key="index">
                  <div class="user-line"
                       :key="user.employeeId + '-' + index">
                    <div class="user-section">
                      <el-checkbox v-model="user.isSelect" style="margin-right: 8px"></el-checkbox>
                      <i @click="editUser(index, user)" class="fa fa-edit" style="margin-right: 8px"/>
                      <span>{{ getName(user.employeeId) }}</span>
                    </div>
                    <div class="user-input-section">
                      <el-input class="padding-input-4" size="small" style="width: 32px; margin-right: 8px"
                                v-model="user.hours"></el-input>
                      <el-input class="padding-input-4" size="small" style="width: 32px" v-model="user.code"></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="user-list" :key="key" v-for="(d, key) in filterGroupUsersWithDir(form.employees, filters)">
                <div v-if="d"
                     style="display: flex; flex: 1; justify-content: flex-start; margin-top: 20px; margin-bottom: -10px">
                  <strong style="color: #4a36cb">{{ getWorkDirName(d) }}</strong>
                </div>

                <div v-if="d" class="user-list" :key="key" v-for="([c, users], key) in d[1]">
                  <div v-if="c" style="display: flex; flex: 1; justify-content: flex-start; margin-top: 20px">
                    <strong>{{ getWorkName(c) }}</strong>
                  </div>
                  <div v-else style="display: flex; flex: 1; justify-content: flex-start; margin-top: 20px">
                    <strong>Без вида работ</strong>
                  </div>
                  <div class="user-container" v-for="(user, index) in users" :key="index">
                    <div class="user-line"
                         :key="user.employeeId + '-' + index">
                      <div class="user-section">
                        <el-checkbox v-model="user.isSelect" style="margin-right: 8px"></el-checkbox>
                        <i @click="editUser(index, user)" class="fa fa-edit" style="margin-right: 8px"/>
                        <span>{{ getName(user.employeeId) }}</span>
                      </div>
                      <div class="user-input-section">
                        <el-input class="padding-input-4" size="small" style="width: 32px; margin-right: 8px"
                                  v-model="user.hours"></el-input>
                        <el-input class="padding-input-4" size="small" style="width: 32px"
                                  v-model="user.code"></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>


          <select-user
            :role="role"
            ref="selectUser"

            @add-user="addUser"
            @update-user="updateUser"
            @delete-user="deleteUser"
            :users="options.users"
            @addNewUser="addNewUser"
            :workDirs="options.dirs"
            :work-types="options.work_type"
            :isWorkType="isWorkType"
            style="margin-top: 20px; margin-bottom: 20px"
            :company="form.company && form.company.id"
            :companyData="form.company"
          />

          <!--        <div v-if="role === 'admin'">-->
          <!--                    <filter-select-->
          <!--                      only-value-->
          <!--                      v-model="form.user"-->
          <!--                      label="Исполнитель"-->
          <!--                      :options="usersOptions"-->
          <!--                    />-->
          <!--        </div>-->
        </div>
        <el-form-item label="Комментарии">
          <el-input type="textarea" v-model="form.comment"></el-input>
        </el-form-item>

        <div>
          <filter-select
            v-model="form.turn"
            label="Смена"
            :options="shifts"
          />
        </div>

        <div style="display: flex; justify-content: flex-start; margin-bottom: 40px; font-weight: bold">

          <router-link style="color: #000" :to="`/dashboard/reports/create/${reportId}/PROF`">
            Отчет #{{ reportName }}
          </router-link>
        </div>

        <div class="create-footer">
          <el-button @click="cancel">Отмена</el-button>
          <el-button type="primary" @click="save" :disabled="!form.company">Сохранить</el-button>
        </div>
      </el-form>
    </div>

    <el-dialog
      title="Копировать отчет"
      :visible.sync="copyData.dialogVisible"
      width="300px"
      v-loading="copyData.loading"
    >
      <div style="display: flex; align-items: center;  flex-direction: column">
        <div>
          <div style="display: flex; flex: 1; margin-bottom: 4px">
            <strong>Дата нового отчета</strong>
          </div>
          <el-date-picker
            v-model="copyData.pickData"
            type="date"
            :editable="false"
            :clearable="false"
            placeholder="Выбрать дату">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="center" style="display: flex; justify-content: center">
        <el-button @click="copyData.dialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="copyReport">Копировать</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AddObjects from './components/AddObjects';
import AddJobs from './components/AddJobs';
import UploadFile from '@/views/Dashboard/Reports/components/UploadFile';
import firebase from 'firebase';
import Multiselect from 'vue-multiselect';
import AddJoint from './components/AddJoint';
import FilterSelect from '../../../components/FilterSelect';
import ListJobs from "./components/ListJobs";
import AddCompany from "./company/AddCompany";
import SelectUser from "./company/SelectUser";
import FilterUser from "./company/FiltersUser";
import MultipleUser from "./company/MultipleUser";
import dayjs from 'dayjs'
import TabelProxy from "../../../proxy/TabelProxy";
import _, {isNumber} from "lodash";
import {getCurrentUser, getRole} from "../../../firestore/permission";
import {filterObjects} from "../../../utils/filterJobs";
import {getChildList} from "../../../utils/getChild";
import {getDirOptions} from "../../../firestore/dirs";

export default {
  name: 'Create',
  components: {
    MultipleUser,
    FilterUser,
    SelectUser, AddCompany, ListJobs, FilterSelect, AddJoint, UploadFile, AddJobs, AddObjects, Multiselect
  },
  data() {
    return {
      reportId: null,
      reportName: '',
      currentUser: {},
      approved: false,
      options: {
        work_type: [],
        users: [],
        dirs: []
      },
      copyData: {
        dialogVisible: false,
        loading: false,
        pickData: dayjs().format('YYYY-MM-DD')
      },
      role: 'worker',
      filters: {
        employeeId: null,
        workTypeId: "",
        code: "",
        personnelNumber: '',
      },
      loading: false,
      loader: false,
      selectAll: false,
      isWorkType: false,
      shifts: [{
        label: 1,
        value: 1,
      }, {
        label: 2,
        value: 2,
      }, {
        label: 3,
        value: 3,
      }],
      index: 1,
      usersOptions: [],
      form: {
        user: null,
        turn: {
          label: 1,
          value: 1,
        },
        timesheetDate: dayjs().format('YYYY-MM-DD'),
        company: null,
        object: null,
        details: {
          employees: [],
          workTypes: [],
          objects: []
        },
        employees: [],
        comment: ''
      }
    }
  },
  async mounted() {
    this.init()
  },
  watch: {
    '$route.params': {
      async handler() {
        await this.init();
      },
      deep: true,
    },
    'form.company': {
      deep: true,
      immediate: true,
      async handler() {
        if (!this.form.company || !this.form.company.id) {
          return this.options.users = []
        }
        const proxy = new TabelProxy({})

        const response = await proxy.list(this.$store.state.project.id)
        this.options.users = response.data.map((data) => {
          return {
            label: data.name,
            value: data._id,
            personnelNumber: data.personnelNumber,
            profId: data.profId,
            companyId: data.companyId
          }
        })

        // this.checkOptionsCache('employees', 'users')
      }
    }
  },
  computed: {
    optionsWorkTypes() {
      const result = [];

      [...(this.options.work_type || [])].forEach((option) => {
        if (this.form.employees.find((user) => user.workTypeId === option.value)) {
          result.push(option)
        }
      })

      // this.checkOptionsCache('workTypes', 'work_type')

      return result
    },
    optionsUsers() {
      const result = [];

      [...(this.options.users || [])].forEach((option) => {
        if (this.form.employees.find((user) => user.employeeId === option.value)) {
          result.push(option)
        }
      })

      // this.checkOptionsCache('employees', 'users')

      return result
    }
  },
  methods: {
    async addNewUser() {
      const proxy = new TabelProxy({})

      const response = await proxy.list(this.$store.state.project.id)
      this.options.users = response.data.map((data) => {
        return {
          label: data.name,
          value: data._id,
          personnelNumber: data.personnelNumber,
          profId: data.profId,
          companyId: data.companyId
        }
      })
    },
    fetchObjectsTree() {
      return new Promise((resolve, reject) => {
        const result = [];
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('objects')
          .get()
          .then((data) => {
            data.forEach((subDoc) => {
              const data = subDoc.data();
              result.push({
                id: subDoc.id,
                name: data.name,
                objects: data.objects,
                index: data.index,
                parentId: data.parentId || undefined,
                isParent: data.isParent,
              });
            });
          }).finally(() => {
          resolve(_.orderBy(getChildList(result), 'index', ['asc']));
        })
      })
    },
    async addObject(n) {
      this.form.object = n;
    },
    getWorkName(id) {
      const work = [...this.options.work_type, ...this.form.details.workTypes].find(({value}) => value === id)
      return work && work.label || ''
    },
    getWorkDirName(id) {
      const work = [...this.options.dirs].find(({value}) => value === id[0])
      return work && work.label || 'Без раздела работ'
    },
    cancel() {
      this.$router.push('/dashboard/reports/TABEL')
    },
    emptyData() {
      return {
        approved: false,
        currentUser: {},
        options: {
          work_type: [],
          users: [],
          companies: [],
          dirs: []
        },
        copyData: {
          dialogVisible: false,
          loading: false,
          pickData: dayjs().format('YYYY-MM-DD')
        },
        filters: {
          employeeId: null,
          workTypeId: "",
          code: "",
          personnelNumber: '',
        },
        loading: false,
        loader: false,
        selectAll: false,
        isWorkType: false,
        user: {},
        shifts: [{
          label: 1,
          value: 1,
        }, {
          label: 2,
          value: 2,
        }, {
          label: 3,
          value: 3,
        }],
        index: '-',
        form: {
          user: null,
          turn: {
            label: 1,
            value: 1,
          },
          details: {
            employees: [],
            workTypes: [],
            objects: []
          },
          timesheetDate: dayjs().format('YYYY-MM-DD'),
          company: null,
          object: null,

          employees: [],
          comment: ''
        }
      }
    },
    checkOptionsCache(name, optionName) {
      if (this.form.details && !this.form.details[name]) {
        return
      }

      this.form.details[name].forEach((obj) => {
        if (!this.options[optionName].find(({value}) => value === obj._id)) {
          this.options[optionName].push({
            label: obj.name,
            value: obj._id
          })
        }
      })
    },
    async init() {
      const companiesResult = []
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .get()
        .then((data) => {

          data.forEach((subDoc) => {
            let _data = subDoc.data();

            companiesResult.push({..._data, id: subDoc.id});
          });
        }).finally(() => {
        this.options.companies = companiesResult.filter((r) => r.isCompany).map(({name, id}) => {
          return {
            label: name,
            value: id
          }
        });
        this.options.companies.push({
          label: 'Все компании',
          value: 'ALL'
        })

        this.options = {...this.options}

        // this.checkOptionsCache('companies', 'companies')
      })


      this.getWorkType()
      this.options.dirs = await getDirOptions(this.$store.state.project.id)


      this.role = await getRole(this.$store.state.project.id);
      this.form = this.emptyData().form
      this.index = '-'
      this.copyData = this.emptyData().copyData
      this.filters = this.emptyData().filters

      const proxy = new TabelProxy({})

      if (this.$route.params.id) {
        let result = []
        const data = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .get()
        data.forEach((subDoc) => {
          let _data = subDoc.data();

          result.push({..._data, id: subDoc.id});
        });

        result = result.filter((r) => r.isCompany);

        const response = await proxy.getTable(this.$route.params.id)
        const tabel = response.data;

        this.reportId = tabel.reportId;
        this.reportName = tabel.reportNumber
        this.approved = tabel.approved;
        this.index = tabel.timesheetNumber;

        let objects = []
        if (tabel.objectId) {
          objects = await this.fetchObjectsTree()
        }

        this.form = {
          user: tabel.timesheet.companyId,
          turn: tabel.timesheet.turn,
          timesheetDate: tabel.timesheet.date,
          company: result.find(({id}) => id === tabel.companyId),
          object: [...objects, ...tabel.details.objects].find(({id}) => id === tabel.objectId),

          employees: tabel.timesheet.employees,
          comment: tabel.comment,
          details: tabel.details
        }
      } else {
        const response = await proxy.getTables(this.$store.state.project.id, {
          limit: 1,
          uid: firebase.auth().currentUser.uid
        })
        console.log(response, 'response , response response response')
        if (response && response[0]) {
          this.index = response[0].timesheetNumber + 1;
        } else {
          this.index = 1
        }
      }


      this.currentUser = await getCurrentUser(this.$store.state.project.id, firebase.auth().currentUser.uid);
    },
    async save() {
      const proxy = new TabelProxy();
      let response = null

      this.loading = true
      if (!this.form.company) {
        return this.$notify({
          offset: 60,
          title: 'Ошибка',
          message: 'Выберите компанию',
          type: 'error',
        });
      }

      if (!this.$route.params.id) {
        const userId = this.$store.state.company.uid || firebase.auth().currentUser.uid;
        response = await proxy.createReport({
          "companyId": this.form.company && this.form.company.id,
          "projectId": this.$store.state.project.id,
          "timesheetDate": dayjs(this.form.timesheetDate).format('YYYY-MM-DD'),
          "comment": this.form.comment,
          "objectId": (this.form.object && this.form.object.id) || '',
          timesheet: JSON.stringify({
            "date": dayjs(this.form.timesheetDate).format('YYYY-MM-DD'),
            "companyId": this.form.user || userId,
            "objectId": (this.form.object && this.form.object.id) || '',
            "turn": this.form.turn,
            "employees": this.form.employees
          })
        })
      } else {
        response = await proxy.updateReport({
          "companyId": this.form.company && this.form.company.id,
          "projectId": this.$store.state.project.id,
          "objectId": (this.form.object && this.form.object.id) || '',
          "timesheetDate": dayjs(this.form.timesheetDate).format('YYYY-MM-DD'),
          "comment": this.form.comment,
          timesheetId: this.$route.params.id,
          timesheet: JSON.stringify({
            "date": dayjs(this.form.timesheetDate).format('YYYY-MM-DD'),
            "companyId": this.form.user,
            "objectId": (this.form.object && this.form.object.id) || '',
            "turn": this.form.turn,
            "employees": this.form.employees
          })
        })

        if (response.errorCode && response.errorCode.includes('APPROVED')) {
          this.$notify.error({title: 'Табель утвержден', message: ''});
        }
      }

      this.loading = false

      if (!response) {
        this.$notify({
          offset: 60,
          title: 'Ошибка',
          message: 'Проверьте корректность введенных данных',
          type: 'error',
        });
      }

      if (response.status === 'success') {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Табель создан',
          type: 'success',
        });
        this.cancel()
      }
    },
    selectAllChange() {
      this.form.employees = this.form.employees.map((user) => {
        return {
          ...user,
          isSelect: this.selectAll
        }
      })
      this.form = {...this.form}
    },
    getTabelNumber(employeeId) {
      if (employeeId) {
        const user = [...this.options.users, ...this.form.details.employees].find(({
                                                                                     value,
                                                                                     _id
                                                                                   }) => employeeId === value || _id === employeeId)

        if (!user) return ''
        return user.personnelNumber
      }
      return ''
    },
    filterGroupUsers(employees, filters) {
      const users = this.filterUsers(employees, filters)
      return _.orderBy(Object.entries(_.groupBy(users, "workTypeId")), 0, ['asc'])
    },
    filterGroupUsersWithDir(employees, filters) {
      const users = this.filterUsers(employees, filters);

      const groupedByDir = _.groupBy(users, "dirId");

      const result = _.mapValues(groupedByDir, dirGroup => {
        return _.orderBy(
          Object.entries(_.groupBy(dirGroup, "workTypeId")),
          [0], ['asc']
        );
      });

      console.log(_.orderBy(Object.entries(result), [0], ['asc']), 'result result')

      // Возвращаем объект, где ключи – это dirId, а значения – массивы групп workTypeId
      return _.orderBy(Object.entries(result), [0], ['asc']);
    },
    filterUsers(employees, filters) {
      let result = [...employees]

      if (filters.employeeId && filters.employeeId.length) {
        result = result.filter(({employeeId}) => filters.employeeId.find(({value}) => employeeId === value))
      }
      if ((filters.workTypeId && filters.workTypeId.length)) {
        result = result.filter(({workTypeId}) => {
          return filters.workTypeId.find(({value}) => workTypeId === value || (!value && !workTypeId))
        })
      }
      if (filters.code || isNumber(filters.code)) {
        result = result.filter(({code}) => code === filters.code)
      }
      if (filters.personnelNumber || isNumber(filters.personnelNumber)) {
        result = result.filter(({employeeId}) => this.getTabelNumber(employeeId) === filters.personnelNumber)
      }

      return result
    },
    applyFilters(filters) {
      this.filters = filters
    },
    addUser(user) {
      this.form.employees.push(user)
      this.form = {...this.form}
    },
    updateUser({index, form}) {
      if (form.workTypeId === 'WITHOUT' || !form.workTypeId) {
        form.workTypeId = ""
      }
      this.form.employees[index] = {...form}

      this.form = {...this.form}
    },
    getName(employeeId) {
      if (employeeId) {
        const user = [...this.options.users, ...this.form.details.employees].find(({
                                                                                     value,
                                                                                     _id
                                                                                   }) => employeeId === value || _id === employeeId)
        if (!user) return ''
        return user.label || user.name
      }
      return ''
    },
    deleteUser(index) {
      this.form.employees.splice(index, 1)
      this.form = {...this.form}
    },
    editUser(index, form) {
      const i = this.form.employees.findIndex((user) => JSON.stringify(user) === JSON.stringify(form))

      this.$refs.selectUser.openEdit(i, {
        ...form,
        label: this.getName(form.employeeId),
        companyId: this.form.company.id
      })
    },
    async getWorkType() {
      const result = []
      const response = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .where('type', 'in', ['job', 'JOB']).get();
      response.forEach((d) => {

        result.push({
          label: d.data().name,
          value: d.id,
          index: d.data().index,
          dir: d.data().dir,
        })
      })
      this.options.work_type = result
    },
    async addCompany(n) {
      this.form.employees = [];
      this.form.company = n;
    },
    async copyReport() {
      const proxy = new TabelProxy();
      this.copyData.loading = true
      const userId = this.$store.state.company.uid || firebase.auth().currentUser.uid;

      const response = await proxy.createReport({
        "companyId": this.form.company.id,
        "projectId": this.$store.state.project.id,
        "timesheetDate": this.copyData.pickData,
        "comment": this.form.comment,
        "objectId": (this.form.object && this.form.object.id) || '',
        timesheet: JSON.stringify({
          "date": this.copyData.pickData,
          "companyId": this.form.user || userId,
          "turn": this.form.turn,
          "employees": this.form.employees
        })
      })

      this.copyData.loading = false

      if (response.status === 'success') {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Табель скопирован',
          type: 'success',
        });

        this.$router.push('/dashboard/reports/create/' + response.data._id + '/TABEL')
      }
    },
    async deleteReport() {
      const proxy = new TabelProxy();
      this.loader = true

      await proxy.deleteTabel(this.$route.params.id)
      this.loader = false

      this.$notify({
        offset: 60,
        title: 'Успешно!',
        message: 'Табель удален',
        type: 'success',
      });
      this.cancel()
    },
    sendReport() {
    }
  },
};
</script>
<style lang="scss" scoped>
.el-icon-success {
  color: #2ecc71 !important;
  font-size: 28px !important;
  margin-left: 4px !important;
}
</style>
<style lang="scss">

.padding-input-4 {
  input {
    padding: 0 4px;
  }
}

.controls-tabel {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}

.creat-reports-vue-container {
  .el-textarea textarea {
    height: 36px;
  }

  .navigate-btn {
    margin-top: 20px;
    display: block;
  }

  .reports-create, .alert-report {
    margin: 0 auto;
    max-width: 382px;
    padding-top: 20px;
    width: calc(100% - 40px);
    overflow: hidden;
    padding-bottom: 100px;

    .add-jobs {
      display: flex;
      flex-direction: column;
    }

    .date-create {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    h4 {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin: 0;

      small {
        font-size: 10px;
        font-weight: 400;
      }
    }
  }

  .add-btn {
    width: 100%;

    > > > .add {
      width: 100%;
    }

    margin-top: 20px;

    &.add-jobs {
      margin-top: 0;
    }
  }

  .select-job {
    margin-top: 20px;

    > > > .el-select {
      width: 100%;
    }
  }

  .report-li {
    span {
    }
  }

  .report-value {
    strong {
      font-weight: bold;
    }
  }

  @media screen and (max-width: 500px) {
    .report-value {
      width: 100%;
      justify-content: space-between !important;
    }

    .report-li {
      display: flex;
      flex-direction: column;
      align-items: flex-start !important;


      .el-icon-close {
        margin-bottom: 12px;
      }

      span {
        max-width: 100%;
        font-weight: bold;
      }
    }
  }

  .report-li-title {
    font-size: 14px;
    margin-top: 18px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0px;
  }

  .report-add-job {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    padding: 20px 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    .report-ul {
      display: flex;
      width: 100%;
      flex-direction: column;
      margin-bottom: 22px;
    }

    .jobs-li {
      border-bottom: 1px solid rgba(0, 0, 0, 0.18);

      &:last-child {
        border-bottom: none;
      }

      padding-bottom: 12px;
    }

    .report-li {
      display: flex;
      margin-top: 3px;
      justify-content: space-between;
      min-height: 58px;
      padding: 12px 0px;
      text-align: left;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.18);
      cursor: pointer;


      &.with-check {
        border-bottom: none;
        padding-bottom: 0px;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .report-file {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    margin-top: 18px;
  }


  .create-footer {
    display: flex;
    justify-content: space-between;
    position: fixed;
    height: 64px;
    border-top: 1px solid #ddd;
    align-items: center;
    max-width: 382px;
    width: calc(100% - 40px);
    bottom: 0;
    background: #fff;
    z-index: 3;
  }

  .report-ul {
    width: 100%;
  }

  .dop-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  > > > .el-form-item, > > > .el-form-item__content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__label {
      padding: 0 !important;
      margin-top: 10px;
    }
  }

  .report-value {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    strong {
      opacity: 0.8;
      font-weight: bold;
    }

    > > > .el-input__inner {
      text-align: right;
      margin-right: 8px;
    }


  }

  .preview-images {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    flex: 1;
    margin-top: 16px;
    margin-bottom: 16px;

    .preview-img {
      width: 92px;
      height: 92px;
      margin: 6px;
    }

    .controls {
      display: flex;
      justify-content: space-between;
      background-color: rgba(0, 0, 0, 0.3);
      width: 92px;
      height: 92px;
      border-radius: 6px;
      margin-top: -98px;
      z-index: 2;
      position: relative;
      align-items: center;

      i {
        font-size: 24px;
        color: #fff;
        margin: 0 12px;
        cursor: pointer;
      }
    }

    img {
      width: 92px;
      height: 92px;
      border-radius: 6px;
      cursor: pointer;
      z-index: 1;
      position: relative;
    }
  }

  .add-block {
    display: flex;
    justify-content: flex-end;
  }

  .line-data {
    padding: 5px 15px;
    margin-bottom: 10px;
    background: #fff;
    background: #f7f7f7;
    box-shadow: 0px 0px 8px 0px #ccc;
    border-radius: 5px;
  }

  .pipe-close {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
    margin-bottom: -42px;
    margin-top: 10px;
    font-size: 20px;
    cursor: pointer;

    i {
      margin-bottom: 10px;
    }

    > > > .add-btn-joint {
      z-index: 2;
      position: relative;
    }
  }

  .reports-edit-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;

    .i-container {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      padding: 6px;
      cursor: pointer;
      border: 1px solid #eee;
      color: #000;
      text-decoration: none;
      flex-direction: column;

      i {
        height: 24px;
      }

      span {
        vertical-align: center;
        display: flex;
        align-items: center;
        font-size: 10px;
        height: 22px;
        margin-top: 6px;
      }

      &:hover {
        background: #eee;
      }
    }
  }

  .reports-create {
    padding: 0 20px;
  }

  .add-job {
    margin-top: -30px;
  }

  .reports-create {
    padding-top: 40px;
    padding-bottom: 70px;
  }

  .report-add-job {
    .line-data {
      padding-top: 24px;
      margin-bottom: 20px;
    }

    .report-ul.mul {
      margin-bottom: 0;
    }

    .add-block {
      margin-top: 30px;
    }

    .report-li > > > .el-form-item__label {
      height: 32px;
    }

    .col-vo {
      > > > .el-input__inner {
        width: 68px !important;
        padding: 0 5px !important;
      }
    }

    .time {
      > > > .el-input__inner {
        width: 58px !important;
        padding: 0 8px 0 2px !important;
        margin-right: 0px;
      }
    }
  }

  .reports-mul {
    > > > .el-form-item__label {
      margin-top: 2px;
    }

    > > > .el-form-item {
      margin-bottom: 10px;
    }
  }

  .total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 14px;
  }

  .links-list {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 20px;
    align-items: center;

    a {
      color: #3676cb;
      font-size: 14px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    i {
      cursor: pointer;
      font-size: 20px;
      opacity: 0.8;
    }
  }

  .report-child-btn {
    display: flex;
    align-items: center;
  }

  .job-link {
    display: flex;
    text-align: left;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

  .isModal {
    .reports-create {
      padding-top: 0 !important;
      border-bottom: none !important;
    }

    .report-add-job {
      border-top: none !important;
    }

    .create-footer {
      position: relative;
      border-top: none;
      width: 100% !important;
    }
  }
}

.user-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;

  span {
    text-align: left;
  }
}

.user-container {
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
}

.user-list {
}


.user-section, .user-input-section {
  display: flex;
  align-items: center;
}

.user-section {
  display: flex;
}

.disabled-next {
  opacity: 0.5;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/CreateTabel.vue